export default __webpack_public_path__ + "static/media/openapi-logo.f0cc3c42.png";